import { Redirect, Switch } from 'react-router'

import { ProtectedRoute } from '@webapp/app/components'
import { useAppRoutes } from '@webapp/hooks/useAppRoutes'
import {
  DiscoverMorePage,
  DiscoverMorePageTabs,
} from '@webapp/platform/discover-more/pages'

const discoverMoreTabFormat = Object.values(DiscoverMorePageTabs).join('|')

export const DiscoverMoreRouter = () => {
  const { url, brp } = useAppRoutes()

  return (
    <Switch>
      <ProtectedRoute
        path={brp('DiscoverMorePage', {
          tab: `:tab(${discoverMoreTabFormat})`,
        })}
        component={DiscoverMorePage}
        featureFlags={['PAY_4551_DISCOVER_MORE_PAGE']}
        isSuperuserRoleRequired
      />

      <Redirect
        path={brp('DiscoverMorePage', { tab: '' })}
        to={url('DiscoverMorePage', {
          tab: DiscoverMorePageTabs.GUIDED_INTAKE,
        })}
      />
    </Switch>
  )
}
